// The small-caps label over a group of rows, with the group's count.
import type { ReactNode } from 'react';
import { cx } from './cx';

export interface SectionHeaderProps { children: ReactNode; count?: number; as?: 'h2' | 'h3'; className?: string }

export function SectionHeader({ children, count, as: Tag = 'h2', className }: SectionHeaderProps) {
  return (
    <Tag className={cx('sec', className)}>
      {children}
      {count !== undefined && <b className="num">{count}</b>}
    </Tag>
  );
}
